/**
 * Spinner — app-wide blocking "working…" overlay, driven by Redux:
 *   setShowSpinner(true[, counter, total])  → show (with a progress bar when total > 0)
 *   setShowSpinner(false)                   → hide
 * Rendered once in containers/App.js. Same state as before; new look (UI kit spinner).
 */
import React from 'react';
import { connect } from 'react-redux';
import { Spin, Progress } from '../../../ui';
import classes from './Spinner.css';

const Spinner = ({ showSpinner, progressBarCounter, progressBarCounterEnd }) => {
  if (!showSpinner) return null;
  const hasProgress = progressBarCounterEnd !== 0 && progressBarCounterEnd !== undefined;
  const percent = hasProgress ? Math.round((progressBarCounter / progressBarCounterEnd) * 100) : 0;
  return (
    <div className={classes.overlay} role="status" aria-live="polite">
      <div className={classes.card}>
        <Spin size="large" />
        {hasProgress ? (
          <div className={classes.progress}>
            <Progress percent={percent} size="small" />
            <span className={`${classes.count} ui-tabular`}>
              {progressBarCounter} / {progressBarCounterEnd}
            </span>
          </div>
        ) : null}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    showSpinner: state.ShowModels.showSpinner,
    progressBarCounter: state.ShowModels.progressBarCounter,
    progressBarCounterEnd: state.ShowModels.progressBarCounterEnd,
  };
};

export default connect(mapStateToProps)(Spinner);
